import { isMeaningfulBusinessDescription } from './quickBrand.js';

export function hasCreateMeaningfulBrandContext(profile) {
  return [profile?.businessDescription, profile?.positioning, profile?.offer, profile?.productOrService]
    .some(isMeaningfulBusinessDescription);
}

export function needsCreateBrandContext(setupStatus) {
  const profile = setupStatus?.profile;
  const hasContext = hasCreateMeaningfulBrandContext(profile);
  return setupStatus?.brand === 'missing'
    || (!hasContext && (Boolean(setupStatus?.bareWorkspace) || setupStatus?.brand === 'present'));
}

export function resolveCreateBrandChoice(previous, { userId, brandId = null, known, hasContext }) {
  const changedContext = previous.userId !== userId || (previous.known && known && previous.brandId !== brandId);
  const next = changedContext ? { userId, brandId, known, value: known ? hasContext : true, explicit: false }
    : { ...previous, userId, brandId: known ? brandId : previous.brandId, known: previous.known || known,
      value: known && !previous.explicit ? hasContext : previous.value };
  return Object.keys(next).every((key) => Object.is(next[key], previous[key])) ? previous : next;
}

export function hasCreateVisualBrandContext(setupStatus, fetchedProfile, primaryLogo) {
  const profile = fetchedProfile || setupStatus?.profile;
  const hasMeaningfulContext = hasCreateMeaningfulBrandContext(profile);
  const hasIdentity = Boolean(primaryLogo || profile?.logoAssetId
    || profile?.brandColors?.some((color) => typeof color === 'string' && color.trim())
    || (profile?.visualStyle && profile.visualStyle !== 'premium_dark'));
  return hasIdentity || hasMeaningfulContext;
}

export function effectiveCreateBrandChoice(choice, hasContext) {
  return Boolean(hasContext && choice?.value);
}

export function collectCreateRailReferences({ enabled, pickedRefs = [], primaryLogo, logoExcluded, useBrand }) {
  if (!enabled) return [];
  return [...pickedRefs, ...(useBrand && primaryLogo && !logoExcluded ? [primaryLogo] : [])];
}

export function resolveCreatePostSubmission({
  noBrand = false,
  prompt = '',
  providedCaption = '',
  textSource = 'ai',
  imageSource = 'ai',
  canPublish = false,
  schedule = 'draft',
  brandKit = true,
}) {
  const ownCaption = textSource === 'write' ? String(providedCaption || '').trim() : '';
  const hasExplicitBrief = String(prompt || '').trim().length >= 3 || ownCaption.length >= 3;
  const fullyManual = textSource === 'write' && ['my', 'none'].includes(imageSource);
  const scheduleMode = !canPublish ? 'draft'
    : ['now', 'spread'].includes(schedule) ? 'publish_now'
    : 'draft';
  let ctaKey = null;
  if (brandKit) {
    if (fullyManual) ctaKey = scheduleMode === 'draft' ? 'createPost.composeSaveDraft' : 'createPost.composePublishNow';
    else if (textSource === 'write' && imageSource === 'ai') ctaKey = 'createPost.composeGenerateImage';
    else if (textSource === 'ai' && imageSource === 'my') ctaKey = 'createPost.composeWriteCaption';
  }
  return {
    fullyManual,
    hasExplicitBrief,
    noBrandBlocksGeneration: Boolean(noBrand && !hasExplicitBrief),
    scheduleMode,
    ctaKey,
  };
}
